import axios from 'axios';

import { responseEntityMapper } from '@qwealth/qcore';
import { QLog, REACT_APP_QWEALTH_API } from '@qwealth/qdata';

import { PostAttachment } from 'data/helpers/attachmentHelper';

export type QLogCreatePayload = Omit<QLog, 'attachments'> & { attachments?: PostAttachment[] };

export type CallLogResult = {
  data: QLog;
  message?: string;
};

export const createCallLog = async (callLog: QLogCreatePayload): Promise<CallLogResult> => {
  const response = await axios.post(`${REACT_APP_QWEALTH_API}/callLogs`, callLog);
  return {
    data: responseEntityMapper<QLog>(response),
    message: response.status === 207 ? response.data?.message : undefined,
  };
};
